import { render, staticRenderFns } from "./CreateCity.vue?vue&type=template&id=31abc869&scoped=true"
import script from "./CreateCity.vue?vue&type=script&lang=js"
export * from "./CreateCity.vue?vue&type=script&lang=js"
import style0 from "./CreateCity.vue?vue&type=style&index=0&id=31abc869&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31abc869",
  null
  
)

export default component.exports